import { render, staticRenderFns } from "./DocIcon.vue?vue&type=template&id=1ad416c0"
import script from "./DocIcon.vue?vue&type=script&lang=ts"
export * from "./DocIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports